//////////////////////////////////////////////////////////////

import { ManufacturerT, SystemWithMetadata } from '@/engine/PlanningAlgorithm/DataTypes';
import type { CardiacSystemMetadata } from './CardiacDevices';

export * from '@/engine/PlanningAlgorithm/DataTypes';

//////////////////////////////////////////////////////////////

export class CardiacManufacturer extends ManufacturerT('DT.CardiacManufacturer') {}

export class CardiacSystem extends SystemWithMetadata<CardiacSystemMetadata>('DT.CardiacSystem') {}
